import { useQuery } from 'hooks/useCustomQuery';
import getCompanies from '@/API/Company/getCompanies';

const useGetCompanyList = async (
    currentPartner,
    currentScope,
    setCompanies,
    enabled = true,
) => {
    return useQuery({
        queryKey: ['companies', { currentScope }],
        queryFn: async () => {
            try {
                const res = await getCompanies(currentPartner, currentScope);
                setCompanies(res.data);
                return res.data;
            } catch (error) {
                throw new Error('Error fetching company list');
            }
        },
        refetchOnWindowFocus: false,
        staleTime: 0,
        enabled: enabled,
    });
};
export default useGetCompanyList;
